<script>
  import { slide, fade } from 'svelte/transition'
  import Icon from './Icon.svelte';

  export let onClose
  export let title = ''

  const clickedBackDrop = event => {
    if (event.target == event.currentTarget ) {
      onClose(event)
    }
  }
</script>

<div
  class="popup-box-bg"
  on:click={e => clickedBackDrop(e)}
  transition:fade|local
>
  <div class="white-box-popup" transition:slide|local>
    {#if title}
      <div class="header-popup">
        <h3>{title}</h3>
        <div on:click={(e) => onClose(e)}><Icon icon="close" /></div>
      </div>
    {/if}

    <div class="popup-middle-text">
      <slot />
    </div>
  </div>
</div>

<style lang="scss">
  .popup-box-bg {
    background: rgba(23, 23, 23, 0.3);
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .white-box-popup {
      background: #FFFFFF;
      border-radius: 12px;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      .header-popup {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 16px 24px;
        border-bottom: 1px solid #EEEEEE;
        align-items: center;
      }
      .header-popup h3 {
        color: #474B50;
        font-weight: 700;
        font-size: 20px;
        margin: 0;
      }
      .popup-middle-text{
        padding: 24px;
        width: 100%;
      }
      .popup-middle-text p{
        color: #616C74;
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
</style>

